import { render, staticRenderFns } from "./McSlider.vue?vue&type=template&id=0a24388a&scoped=true&"
import script from "./McSlider.vue?vue&type=script&lang=js&"
export * from "./McSlider.vue?vue&type=script&lang=js&"
import style0 from "./McSlider.vue?vue&type=style&index=0&id=0a24388a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a24388a",
  null
  
)

export default component.exports